import { ContactGroupType } from 'contacts/enums';
import { IContact, IContactGroup } from 'contacts/types';
import { useNotificationContext } from 'core/states';

import { AddContactGroupByEmailSteps } from './AddContactGroupByEmailSteps';
import { AddContactGroupByEmailProvider } from './state';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  contactGroupType: ContactGroupType;
  searchContact?: boolean;
  onSearchCustomerSuccess?: (contact: IContact, contactGroup?: IContactGroup) => void;
  level?: number;
}

export const AddContactGroupByEmail = ({
  isOpen,
  onClose,
  contactGroupType = ContactGroupType.CUSTOMER,
  searchContact = false,
  onSearchCustomerSuccess,
  level,
}: IProps) => {
  const { clearNotification } = useNotificationContext();

  const handleOnClose = () => {
    clearNotification();
    onClose();
  };

  return (
    <AddContactGroupByEmailProvider
      onClose={handleOnClose}
      contactGroupType={contactGroupType}
      searchContact={searchContact}
      onSearchCustomerSuccess={onSearchCustomerSuccess}
    >
      <AddContactGroupByEmailSteps isOpen={isOpen} level={level} />
    </AddContactGroupByEmailProvider>
  );
};
